import { render, staticRenderFns } from "./ChooseRegistrationType.vue?vue&type=template&id=7b0f66f6&"
import script from "./ChooseRegistrationType.vue?vue&type=script&lang=ts&"
export * from "./ChooseRegistrationType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports